export default __webpack_public_path__ + "static/coperta-campanii-concursuri-card-7145871af2f2592c485f079617801c7f.jpg";